import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_ROADWAY } from "../../../../../common/constants/appRoad"
import { useRoadQuery } from "../../../../../common/hooks/queries/useRoadQuery"

import { networkGradingsQueryKeys } from "./queryKeys"
import { useWeightedAverageGrades } from "./useWeightedAverageGrades"

export function useFeaturesYearGrading(year, road, absStart, absEnd, config = {}) {
    const roadParams = {
        linear_location_road: road,
        linear_location_start: absStart,
        linear_location_end: absEnd,
        year,
    }

    const featureParameters = useExtendWithSubnetworks(roadParams, API_MODULE_ROADWAY)
    const featureQueryKey = [...networkGradingsQueryKeys["list"](featureParameters)]
    const featureUrl = "segment_gradings/"
    const { data: featuresData, isLoading: isFeatureLoading, isError: isFeatureError } = useRoadQuery(
        featureUrl,
        featureQueryKey,
        featureParameters,
        {
            ...config,
            geometry__isnull: false,
        })

    const averageGrades = useWeightedAverageGrades(featuresData)

    return ({
        data: averageGrades,
        isLoading: isFeatureLoading,
        isError: isFeatureError,
    })
}